import { useEffect, useState } from 'react'

// Trailing-edge debounce: returns `value` only after it has been stable for `delayMs`.
// Every change resets the timer, so mid-typing values never surface to consumers and
// per-keystroke contract reads stay off the RPC.
export function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delayMs)
        return () => clearTimeout(timer)
    }, [value, delayMs])

    return debounced
}
